// reportTargetLink — the logic behind the Reports show page's "Open X" link
// next to the reported target, split out of show.tsx (same rationale as
// groupReportLink.ts) so it's testable without mounting the page's full
// Refine (useShow/useUpdate/useGetIdentity) harness. Pure — no React, no
// network — so a future target_type just adds a switch case here.
import { memoryCommentPath } from '../memory_comments/list'

export interface ReportTargetLink {
  to: string
  label: string
}

/** Where the reported thing lives in the admin, or null when it has no page here. */
export function reportTargetLink(targetType: string, targetId: string | null | undefined): ReportTargetLink | null {
  if (!targetId) return null
  switch (targetType) {
    case 'business':
      return { to: `/businesses/show/${targetId}`, label: 'Open listing' }
    case 'photo':
      // Gallery photos AND Classroom memories — a memory is reported as 'photo'.
      return { to: `/photos/show/${targetId}`, label: 'Open photo' }
    case 'memory_comment':
      return { to: memoryCommentPath(targetId), label: 'Open comment' }
    default:
      return null
  }
}
